
import ProtectUser from '../app/protectUser';
import ContactSupport from '../components/ContactSupport';
import Navbar from '../layout/userNav/Navbar';
import { DashboardWrapper } from '../styles';


const AppWrapper = ({ children, pagename, route }) => {


    return (
        <main>
            <ProtectUser>
                <div className="dark-text">
                    <Navbar
                        pagename={pagename}
                        route={route}

                    />
                    <DashboardWrapper>
                        <div className='container-fluid'>
                            {/* <MainAlert /> */}
                            {children}
                        </div>
                        <ContactSupport />
                    </DashboardWrapper>

                </div>
            </ProtectUser>
        </main>
    );
};

export default AppWrapper;